var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 11.667a5 5 0 1 0 0-10.001 5 5 0 0 0 0 10M10 2.5a4.17 4.17 0 0 1 4.167 4.167A4.17 4.17 0 0 1 10 10.833a4.17 4.17 0 0 1-4.167-4.166A4.17 4.17 0 0 1 10 2.5M10 13.333c3.258 0 6.088 2.035 7.482 5h.851C16.885 14.892 13.7 12.5 10 12.5s-6.885 2.392-8.333 5.833h.851c1.393-2.965 4.222-5 7.482-5"
  })));
};
export default SvgUser;